import { render, staticRenderFns } from "./mobile_offlineversion.vue?vue&type=template&id=ca4db334&scoped=true"
import script from "./mobile_offlineversion.vue?vue&type=script&lang=js"
export * from "./mobile_offlineversion.vue?vue&type=script&lang=js"
import style0 from "./mobile_offlineversion.vue?vue&type=style&index=0&id=ca4db334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4db334",
  null
  
)

export default component.exports